import FileCheck02 from '@untitled-ui/icons-react/build/esm/FileCheck02';

import { Tooltip } from 'antd';
import { useToast } from 'providers/ToastProvider';
import { BaseButton } from './BaseButton';

interface RecordType {
  kycLoginUrl: string;
  status?: string;
}

interface RedirectButtonProps {
  record: RecordType;
}

export const RedirectButton = ({ record }: RedirectButtonProps) => {
  const toast = useToast();

  if (record?.status === 'Expired') {
    return null;
  }

  const handleRedirect = () => {
    if (!record.kycLoginUrl) {
      toast.warning('No URL found.');
      return;
    }

    window.open(record.kycLoginUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title="Redirect to Verification Page">
      <BaseButton
        className="secondary-button min-h-8 min-w-8"
        icon={<FileCheck02 className="h-4 w-4" />}
        onClick={handleRedirect}
      />
    </Tooltip>
  );
};

export default RedirectButton;
